import styled from 'styled-components';
import { Body3Template } from '../../../../shared/typography/body3';
import { Body4Template } from '../../../../shared/typography/body4';
import { Headline4dmTemplate } from '../../../../shared/typography/headline4dm';

export const FooterItem = styled.li`
  ${({ isBold, isFeaturedLink }) =>
    (isFeaturedLink && Headline4dmTemplate) || (isBold && Body3Template) || Body4Template};
  align-items: center;
  color: ${({ theme, isBottomItem }) => (isBottomItem ? theme.medGray : theme.darkGray)};
  display: flex;
  justify-content: space-between;
  &:hover {
    color: ${({ theme }) => theme.oneAppBlue};
  }
`;
